import { create } from "zustand";
import { axiosHelper, tokenHelper } from "../helpers";
import { filterNonFalseValues } from "../helpers/Utlis";

export const useLinksStore = create((set, get) => ({
  links: [],
  siteLinks: [],
  isLoading: false,
  isError: false,
  error: undefined,
  pagination: null,
  siteLinksPagination: null,

  filters: {
    code: "",
    DestProv: "",
    dateFrom: "",
    dateTo: "",
    access: "",
    driverId: "",
    charger: false,
  },
  // Methods
  createLink: async (body) => {
    set({ isLoading: true });

    try {
      // Get the access token
      const accessToken = await tokenHelper.getToken();

      // Post the site creation request
      const response = await axiosHelper.post("/user/link-space2", body, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      await get().getLinks();
      return true;
    } catch (e) {
      console.log(e);
      return false;
    } finally {
      set({ isLoading: false });
    }
  },
  removeLink: async (body) => {
    set({ isLoading: true });

    try {
      // Get the access token
      const accessToken = await tokenHelper.getToken();

      // Post the site creation request
      const response = await axiosHelper.post("/user/unlink-space2", body, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      await get().getLinks();
      return true;
    } catch (e) {
      console.log(e);
      return false;
    } finally {
      set({ isLoading: false });
    }
  },
  getLinks: async (filters, { page, perPage }) => {
    try {
      const accessToken = await tokenHelper.getToken();
      set({ isLoading: true });
      let response = await axiosHelper.post(
        `/user/get-all-space-links?page=${page}&perPage=${perPage}`,
        filters,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );


      set({
        links: response?.links,
        pagination: response?.pagination,
        isLoading: false,
      });
      return response;
    } catch (e) {
      console.log(e);
    } finally {
      set({ isLoading: false });
    }
  },

  // Create multiple space links at once
  createLinkMultiple: async (body) => {
    set({ isLoading: true });

    try {
      const accessToken = await tokenHelper.getToken();
      const response = await axiosHelper.post("/user/link-spaces-multiple", body, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      await get().getLinks(null, { page: 1, perPage: 10 });
      return true;
    } catch (e) {
      console.log(e);
      return false;
    } finally {
      set({ isLoading: false });
    }
  },

  // Create site link (user to site without space)
  createSiteLink: async (body) => {
    set({ isLoading: true });

    try {
      const accessToken = await tokenHelper.getToken();
      const response = await axiosHelper.post("/user/link-sites", body, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      await get().getSiteLinks({ page: 1, perPage: 10 });
      return true;
    } catch (e) {
      console.log(e);
      return false;
    } finally {
      set({ isLoading: false });
    }
  },

  // Remove site link
  removeSiteLink: async (body) => {
    set({ isLoading: true });

    try {
      const accessToken = await tokenHelper.getToken();
      const response = await axiosHelper.post("/user/unlink-site", body, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      await get().getSiteLinks({ page: 1, perPage: 10 });
      return true;
    } catch (e) {
      console.log(e);
      return false;
    } finally {
      set({ isLoading: false });
    }
  },

  // Get site links (users linked to sites without spaces)
  getSiteLinks: async ({ page, perPage }) => {
    try {
      const accessToken = await tokenHelper.getToken();
      set({ isLoading: true });
      let response = await axiosHelper.get(
        `/user/get-site-links?page=${page}&perPage=${perPage}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );


      set({
        siteLinks: response?.links || [],
        siteLinksPagination: response?.pagination,
        isLoading: false,
      });
      return response;
    } catch (e) {
      console.log(e);
      set({ siteLinks: [], isLoading: false });
    }
  },

  setFilters: (filters) => {
    set({ filters: filterNonFalseValues(filters) });
  },

  // Check if user exists by email
  checkUserExists: async (email) => {
    try {
      const accessToken = await tokenHelper.getToken();
      const response = await axiosHelper.get(`/user/check-email/${email}`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      return response?.data?.exists || false;
    } catch (e) {
      console.log(e);
      return false;
    }
  },

  // Send email invitation to user
  sendEmailInvitation: async (body) => {
    set({ isLoading: true });

    try {
      const accessToken = await tokenHelper.getToken();
      const response = await axiosHelper.post("/user/send-invitation", body, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      return true;
    } catch (e) {
      console.log(e);
      return false;
    } finally {
      set({ isLoading: false });
    }
  },
}));
